module.exports = __webpack_public_path__ + "img/gold_img.201a7368.png";